import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main'
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  project_id: payload.project.id,
  number: payload.number,
  folio: payload.folio,
  currency_id: payload.currency_id,
  exchange_rate: payload.exchange_rate,
  requisitor: payload.requisitor,
  tax_type: payload.tax_type,
  payment_deadline: payload.payment_deadline,
  details: payload.details
})
var crud = new Crud('CustomerPurchaseOrders', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  customerPurchaseOrders: [],
  catalog: {
    currencies: []
  },
  details: [],
  isModalImportCustomerPurchaseOrderDetailVisible: false
}

const mutations = {
  ...crud.mutations,
  SET_MODAL_IMPORT_CUSTOMER_PURCHASE_ORDER_DETAIL_VISIBLE (state, payload) {
    state.isModalImportCustomerPurchaseOrderDetailVisible = payload
  },
  SET_PRODUCT_DETAIL (state, payload) {
    state.details = payload
  },
  SET_DETAILS_IMPORT (state, payload) {
    state.details.push(...payload)
  }
}

const actions = {
  ...crud.actions,
  setModalImportCustomerPurchaseOrderDetailVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_CUSTOMER_PURCHASE_ORDER_DETAIL_VISIBLE', payload)
  },
  async downloadTemplate ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${Vue.axios.defaults.baseURL}/${payload.model}/template`)
    } catch (error) {
      app.$Progress.fail()
    } finally {
      app.$Progress.finish()
    }
  },
  async importCustomerPurchaseOrderDetail ({ commit }, payload) {
    let formData = new FormData()
    payload.files.forEach(file => {
      formData.append('importFile', file)
    })
    app.$Progress.start()

    try {
      const response = await axios.post(`customer-purchase-order-details/${payload.id}/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_IMPORT_CUSTOMER_PURCHASE_ORDER_DETAIL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.requisition_detail', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setProductDetails ({ commit }, payload) {
    commit('SET_PRODUCT_DETAIL', payload)
  }
}

const getters = {
  ...crud.getters,
  customerPurchaseOrders: state => state.customerPurchaseOrders,
  details: state => state.details,
  isModalImportCustomerPurchaseOrderDetailVisible: state => state.isModalImportCustomerPurchaseOrderDetailVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
